const TITLE_ACRONYMS = new Set([
  "abm",
  "ai",
  "api",
  "b2b",
  "b2c",
  "cac",
  "ceo",
  "cfo",
  "cmo",
  "crm",
  "cto",
  "pdf",
  "roi",
  "roas",
  "seo",
]);

function titleCaseWord(word) {
  const lower = word.toLowerCase();
  if (TITLE_ACRONYMS.has(lower)) return lower.toUpperCase();
  if (/[A-Z]/.test(word.slice(1))) return word;
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function withPdfExtension(fileName, fallback = "document.pdf") {
  const name = String(fileName || fallback).trim() || fallback;
  return name.toLowerCase().endsWith(".pdf") ? name : `${name}.pdf`;
}

export function titleCasePdfName(fileName) {
  const name = withPdfExtension(fileName);
  const stem = name.replace(/\.pdf$/i, "");
  const titledStem = stem
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/[A-Za-z][A-Za-z0-9']*/g, titleCaseWord);
  return `${titledStem || "Document"}.pdf`;
}

export function suggestChatReplyPdfFileName(messageText, preferredName) {
  const preferred = preferredName && String(preferredName).trim();
  if (preferred) return titleCasePdfName(preferred);

  const line = String(messageText || "")
    .split("\n")
    .map((l) => l.trim())
    .find(Boolean);
  const base = line || "MarkBase-reply";
  const slug = base
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 48);
  const d = new Date().toISOString().slice(0, 10);
  return titleCasePdfName(`${slug || "MarkBase-reply"}-${d}.pdf`);
}

export function normalizePdfBase64(raw) {
  let s = String(raw ?? "").trim().replace(/\s/g, "");
  if (/^data:application\/pdf/i.test(s)) {
    const comma = s.indexOf(",");
    if (comma !== -1) s = s.slice(comma + 1);
  }
  return s;
}

export function base64PdfToBlob(base64) {
  const clean = normalizePdfBase64(base64);
  if (!clean) throw new Error("Empty PDF payload");
  const binary = atob(clean);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: "application/pdf" });
}

/** Chunked binary → base64 (e.g. PDF bytes extracted from a ZIP). */
export function uint8ArrayToBase64(bytes) {
  if (!(bytes instanceof Uint8Array) || bytes.length === 0) return "";
  const chunkSize = 0x8000;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const sub = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, sub);
  }
  return btoa(binary);
}

export function downloadBase64Pdf(base64, fileName) {
  const blob = base64PdfToBlob(base64);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = titleCasePdfName(fileName);
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
